// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SharedExternalIdModel {
    static getAttributeTypeMap() {
        return SharedExternalIdModel.attributeTypeMap;
    }
}
SharedExternalIdModel.discriminator = undefined;
SharedExternalIdModel.additionalProperties = false;
SharedExternalIdModel.attributeTypeMap = [
    {
        "name": "id",
        "baseName": "id",
        "type": "number"
    },
    {
        "name": "externalIdType",
        "baseName": "externalIdType",
        "type": "PartyExternalIdType"
    },
    {
        "name": "externalId",
        "baseName": "externalId",
        "type": "string"
    },
];
//# sourceMappingURL=sharedExternalIdModel.js.map